import axios from "axios";
import main from "../main"

const client = axios.create({ baseURL: process.env.VUE_APP_API_URL });


async function authentication(request) {
    await main.$store.state.authentication.keycloak.updateToken(5)

    request.headers['Authorization'] = `Bearer ${main.$store.state.authentication.keycloak.token}`;

    return request;
}

function organizer(request) {
    if (!request.params) request.params = {}

    request.params.organizer = main.$route.params.organizer;

    return request;
}


client.interceptors.request.use(organizer);
client.interceptors.request.use(authentication);


export default {
    get(url, options) {
        return client.get(url, options);
    },

    post(url, data = {}, options = {}) {
        return client.post(url, data, options);
    },

    patch(url, data = {}, options = {}) {
        return client.patch(url, data, options);
    },

    delete(url, options = {}) {
        return client.delete(url, options);
    }
};
